<div
  *ngIf="validators && (validators | validatorsList: value).length"
  class="alert alert-danger"
>
  <p *ngFor="let validationEror of validators | validatorsList: value">
    {{ validationEror }}
  </p>
</div>
